import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import Box from '@mui/material/Box'

import { getMaxRevenue } from './selectors'

const RevenueBar = ({ revenueCurrent, revenueMax }) => (
  <Box className="search-list_item-revenue-bar">
    <Box className="progress-wrapper">
      <span className="progress-line" style={{ width: `${(revenueCurrent * 100) / revenueMax}%` }} />
    </Box>
  </Box>
)

RevenueBar.propTypes = {
  revenueCurrent: PropTypes.number,
  revenueMax: PropTypes.number,
}

const mapStateToProps = state => ({
  revenueMax: getMaxRevenue(state),
})

export default connect(mapStateToProps)(RevenueBar)
